import { useCallback } from 'react';

import { useEnvironment } from '@wix/yoshi-flow-editor';

import { minimizeWidget, reportNavigation } from '@/features';
import { useAppDispatch } from '@/store';
import { getCurrentPathName } from '@/utils';

import { useSiteNavigation } from 'AiAssistantWidget/Widget/contexts';

export const useLinkHandler = (
  url: string = '',
  reportNavigationToAssistant?: { id: string },
) => {
  const dispatch = useAppDispatch();
  const { isMobile } = useEnvironment();
  const { navigateToUrl, baseUrl } = useSiteNavigation();
  const isFullInternalUrl = url.startsWith(baseUrl);
  const isOwn = isFullInternalUrl || url.startsWith('/');

  let link = url;
  try {
    if (isFullInternalUrl) {
      const urlObj = new URL(url);
      link = urlObj.pathname;
    }
  } catch (e) {}

  const handleLinkClick = useCallback(async () => {
    if (isMobile) {
      dispatch(minimizeWidget());
    }

    const currentPath = getCurrentPathName(baseUrl);

    if (isOwn && link !== currentPath) {
      await dispatch(
        reportNavigation({
          id: reportNavigationToAssistant?.id ?? link,
          path: link,
          source: 'chat',
        }),
      );
    }

    navigateToUrl(url);
  }, [
    dispatch,
    isMobile,
    url,
    navigateToUrl,
    link,
    isOwn,
    reportNavigationToAssistant,
    baseUrl,
  ]);
  return {
    isOwn,
    handleLinkClick,
  };
};
